import React from 'react';

import Heading from 'pages/SignUp/components/Heading';

import RadioGroup from 'shared/RadioGroup';

import { Option, Props } from './initial.types';

const ITEMS = [
  { label: 'I don’t know anything', value: 'i_dont_know_anything' },
  { label: 'I’ve heard of them, but don’t know much', value: 'i_ve_heard_of_them' },
  {
    label: 'I’m currently taking GLP-1 medication',
    subtitle: 'Wegovy, Zepbound, Semaglutide, other',
    value: 'currently_taking'
  },
  {
    label: 'I was taking GLP-1 medication before',
    subtitle: 'Looking to switch providers and save money',
    value: 'i_was_taking_before'
  },
  { label: 'I want to learn more about GLP-1s', value: 'i_want_to_learn_more' }
];

const getOptions = (options: Option[]) => {
  const Option = ({ label, subtitle }: { label: string; subtitle?: string }) => (
    <div className="flex flex-col gap-0.5">
      <span className="">{label}</span>
      {!!subtitle && <span className="text-mSm text-gray md:text-sm">{subtitle}</span>}
    </div>
  );

  return options.map((option) => ({
    label: <Option key={option.value} {...option} />,
    value: option.value
  }));
};

const Initial: React.FC<Props> = ({ loading, onSelect, value }) => {
  return (
    <>
      <Heading category="Eligibility" title="How familiar are you with GLP-1s?" />
      <RadioGroup
        isLoading={loading}
        items={getOptions(ITEMS)}
        selectedItem={value}
        onSelect={onSelect}
      />
    </>
  );
};

export default Initial;
